/**
 * 归档页懒加载壳（14.36b；AboutLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function ArchiveLazy() {
  const { mod } = useLazyModule(() => import('./ArchivePage'));
  if (mod === null) return <div data-testid="archive-loading-shell">加载中…</div>;
  return <mod.ArchivePage />;
}
